import { Axis, Orientation } from '@visx/axis';
import { ScaleTime } from 'd3-scale';
import { getDateTickFormatter } from 'dashboard-engine/util/tickDateFormatter';
import { tickCount } from 'dashboard-engine/util/tickFormatter';
import { useMemo } from 'react';
import { GridLineExtension } from '../../components/GridLineExtension';

export interface FormattedTick {
    tick: Date;
    x: number;
    formattedTickValue: string;
}

interface XAxisProps {
    scale: ScaleTime<number, number, never>;
    innerWidth: number;
    innerHeight: number;
    marginTop: number;
    hideAxisLine: boolean;
    label?: string;
}

export const XAxis: React.FC<XAxisProps> = ({ scale, innerWidth, innerHeight, marginTop, hideAxisLine, label }) => {
    const formattedTicks = useMemo(() => {
        const tickValues = scale.ticks(tickCount(innerWidth)) as unknown as Date[];

        const computedTickFormatter = getDateTickFormatter(tickValues);

        return tickValues.map((tick) => ({
            tick,
            x: scale(tick),
            formattedTickValue: computedTickFormatter(tick)
        }));
    }, [scale, innerWidth]);

    const tickElements = formattedTicks.map(({ formattedTickValue, tick, x }: FormattedTick, idx) => (
        <g key={`${tick.toISOString()}_${idx}`} transform={`translate(${x}, 0)`}>
            <GridLineExtension />
            <text
                y={0}
                x={0}
                className='fill-textSecondary'
                style={{
                    fontSize: '11px',
                    fontFamily: 'Inter',
                    letterSpacing: '0px'
                }}
                textAnchor='middle'
            >
                {formattedTickValue}
            </text>
        </g>
    ));

    return (
        <>
            <Axis
                orientation={Orientation.bottom}
                top={innerHeight + marginTop}
                scale={scale}
                tickComponent={() => null}
                hideAxisLine={hideAxisLine}
                hideTicks={true}
                axisLineClassName='stroke-dividerTertiary'
                label={label}
                labelClassName='fill-textSecondary'
                labelProps={{
                    fontSize: 12,
                    fontFamily: 'Inter',
                    textAnchor: 'middle'
                }}
            />
            <g transform={`translate(0, ${innerHeight + marginTop + 25})`}>{tickElements}</g>
        </>
    );
};
